import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  getCheckoutDisclaimerHtml,
  type CheckoutDisclaimerFxDisplay,
} from '../utils/checkoutDisclaimer';
import { selectPlanDetails, selectPlanCoupon } from '../store/plans';

interface UseCheckoutDisclaimerHtmlOptions {
  fxDisplay?: CheckoutDisclaimerFxDisplay | null;
}

export const useCheckoutDisclaimerHtml = ({
  fxDisplay = null,
}: UseCheckoutDisclaimerHtmlOptions = {}) => {
  const { t } = useTranslation();
  const planDetails = useSelector(selectPlanDetails);
  const couponDetails = useSelector(selectPlanCoupon);

  return useMemo(
    () =>
      getCheckoutDisclaimerHtml({
        planDetails,
        couponPrice: couponDetails?.price ?? 0,
        t,
        fxDisplay,
      }),
    [planDetails, couponDetails, t, fxDisplay],
  );
};
